import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { BookmarkSortModel } from 'src/app/bookmarks/models/bookmark-sort.model';
import { ExploreCategoryModel } from '../models/explore-category.model';

export class ExploreStateModel {
    query: string;
    loading: boolean;
    searching: boolean;
    searchResults: BookmarkModel[];
    sort: BookmarkSortModel;
    checkedSearchResults: string[];
    selectedCategory?: ExploreCategoryModel;
}
